import { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import withStyles from "@mui/styles/withStyles";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";

// MATERIAL ICONS
import IconButton from "@mui/material/IconButton";
import IconChevronLeft from "@mui/icons-material/ChevronLeft";
import IconChevronRight from "@mui/icons-material/ChevronRight";

const WIDTH_EXPANDED = 240;
const WIDTH_COLLAPSED = 60;

const styles = theme => ({
  root: {
    width: WIDTH_EXPANDED,
    flexShrink: 0,
    whiteSpace: "nowrap",
    zIndex: theme.zIndex.drawer,
  },
  paper: {
    position: "relative",
  },
  open: props => ({
    width: props.width || WIDTH_EXPANDED,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  closed: {
    width: WIDTH_COLLAPSED,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(1),
  },
});

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }
  //_________________________________________________________
  handleDrawerOpen = () => {
    if (this.props.handleDrawerOpen && typeof this.props.handleDrawerOpen === "function") {
      this.props.handleDrawerOpen();
    } else {
      this.setState({ open: true });
    }
  };
  //_________________________________________________________
  handleDrawerClose = () => {
    if (this.props.handleDrawerClose && typeof this.props.handleDrawerClose === "function") {
      this.props.handleDrawerClose();
    } else {
      this.setState({ open: false });
    }
  };
  render() {
    const { classes, theme, open: openFromProps, noShadow, closable = true } = this.props;
    const open = closable ? (openFromProps !== undefined ? openFromProps : this.state.open) : true;
    return (
      <Drawer
        variant="permanent"
        className={classNames(classes.root, {
          [classes.open]: open,
          [classes.closed]: !open,
        })}
        classes={{
          paper: classNames(classes.paper, {
            [classes.open]: open,
            [classes.closed]: !open,
          }),
        }}
        style={{
          boxShadow: !noShadow && theme.shadows[8],
        }}
        open={open}
      >
        {closable && (
          <>
            <div className={classes.toolbar}>
              {open ? (
                <IconButton onClick={this.handleDrawerClose} size="large">
                  {theme.direction === "rtl" ? <IconChevronRight /> : <IconChevronLeft />}
                </IconButton>
              ) : (
                <IconButton onClick={this.handleDrawerOpen} size="large">
                  {theme.direction === "rtl" ? <IconChevronLeft /> : <IconChevronRight />}
                </IconButton>
              )}
            </div>
            <Divider />
          </>
        )}
        {this.props.children}
      </Drawer>
    );
  }
}

SideBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool, // can control from parent if desired
  handleDrawerOpen: PropTypes.func,
  handleDrawerClose: PropTypes.func,
  noShadow: PropTypes.bool,
  /** Allow drawer to be closable. Set to false to stay open and hide collapse button. Default is true. */
  closable: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(SideBar);
